import { Action } from '@ngrx/store';
import { AppState } from './app-state';
import { UserActions } from './features/auth/user-actions.enum';

export function resetStateMetaReducer(
  reducer: (state: AppState, action: Action) => AppState,
) {
  return (state: AppState, action: Action) => {
    if (action.type === UserActions.LOGOUT) return reducer(new AppState(), action);

    return reducer(state, action);
  };
}
